export default {
  // Common
  common: {
    welcome: 'مرحباً',
    loading: 'جارٍ التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    search: 'بحث...',
    filter: 'تصفية',
    export: 'تصدير',
    refresh: 'تحديث',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    confirm: 'تأكيد',
    yes: 'نعم',
    no: 'لا',
    close: 'إغلاق',
    actions: 'إجراءات',
    status: 'الحالة',
    active: 'نشط',
    inactive: 'غير نشط',
    enabled: 'مفعّل',
    disabled: 'معطّل',
    success: 'نجاح',
    error: 'خطأ',
    warning: 'تحذير',
    info: 'معلومات',
    apply: 'تطبيق',
    download: 'تنزيل',
    upload: 'رفع',
    view: 'عرض',
    details: 'تفاصيل',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    country: 'الدولة',
    city: 'المدينة',
    state: 'الولاية',
    zipCode: 'الرمز البريدي',
    createdAt: 'تاريخ الإنشاء',
    updatedAt: 'تاريخ التحديث',
    description: 'الوصف',
    type: 'النوع',
    amount: 'المبلغ',
    date: 'التاريخ',
    time: 'الوقت',
    from: 'من',
    to: 'إلى',
    all: 'الكل',
    none: 'لا شيء',
    select: 'اختيار',
    selected: 'محدد',
    total: 'الإجمالي',
    subtotal: 'المجموع الفرعي',
    pending: 'قيد الانتظار',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    completed: 'مكتمل',
    failed: 'فشل',
    processing: 'جارٍ المعالجة',
    cancelled: 'ملغى',
    required: 'مطلوب',
    optional: 'اختياري',
    today: 'اليوم',
    yesterday: 'أمس',
    thisWeek: 'هذا الأسبوع',
    thisMonth: 'هذا الشهر',
    lastMonth: 'الشهر الماضي',
    custom: 'مخصص',
    range: 'نطاق',
    noData: 'لا توجد بيانات متاحة',
    noResults: 'لا توجد نتائج',
    showMore: 'عرض المزيد',
    showLess: 'عرض أقل',
    expand: 'توسيع',
    collapse: 'طي',
    clearAll: 'مسح الكل',
    selectAll: 'تحديد الكل',
    deselectAll: 'إلغاء تحديد الكل',
    copyToClipboard: 'نسخ إلى الحافظة',
    copied: 'تم النسخ!',
    notAvailable: 'غير متاح',
    upgrade: 'ترقية',
  },

  // Auth
  auth: {
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    rememberMe: 'تذكّرني',
    forgotPassword: 'نسيت كلمة المرور؟',
    signIn: 'دخول',
    signUp: 'تسجيل',
    loginSuccess: 'تم تسجيل الدخول بنجاح',
    loginError: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
    sessionExpired: 'انتهت الجلسة. يرجى تسجيل الدخول مجدداً.',
    adminPanel: 'لوحة الإدارة',
    needHelp: 'تحتاج مساعدة؟',
    poweredBy: 'مدعوم من',
  },

  // Navigation
  nav: {
    dashboard: 'لوحة التحكم',
    instruments: 'الأدوات المالية',
    clients: 'العملاء',
    accounts: 'الحسابات',
    trading: 'التداول',
    reports: 'التقارير',
    auditLog: 'سجل المراجعة',
    withdrawals: 'السحوبات',
    deposits: 'الإيداعات',
    settings: 'الإعدادات',
    plugins: 'الإضافات',
    accountGroups: 'مجموعات الحسابات',
    kyc: 'التحقق من الهوية',
    apiDocs: 'وثائق API',
    notifications: 'الإشعارات',
    upgrade: 'ترقية',
    groupPricing: 'تسعير المجموعة',
  },

  // Dashboard
  dashboard: {
    title: 'لوحة التحكم',
    overview: 'نظرة عامة',
    stats: 'الإحصائيات',
    totalClients: 'إجمالي العملاء',
    totalAccounts: 'إجمالي الحسابات',
    openPositions: 'الصفقات المفتوحة',
    todayPnL: 'الربح والخسارة اليوم',
    liveAccounts: 'الحسابات الحية',
    demoAccounts: 'الحسابات التجريبية',
    activeClients: 'العملاء النشطون',
    activeTraders: 'المتداولون النشطون',
    newClients: 'العملاء الجدد',
    volumeChart: 'حجم التداول (7 أيام)',
    pnlTrend: 'اتجاه الربح والخسارة (30 يوم)',
    recentActivity: 'النشاط الأخير',
    quickActions: 'إجراءات سريعة',
    financialOverview: 'نظرة عامة مالية',
    financialOverview30Days: 'نظرة عامة مالية (30 يوم)',
    riskAlerts: 'تنبيهات المخاطر',
    riskDistribution: 'توزيع المخاطر',
    currentPlan: 'الخطة الحالية',
    planUsage: 'استخدام الخطة',
    allowedMarkets: 'الأسواق المسموح بها',
    accountOverview: 'نظرة عامة على الحسابات',
    activeUsers: 'المستخدمون النشطون',
    activeThisMonth: 'نشط هذا الشهر',
    plan: 'خطة',
    feedLatency: 'تأخير البيانات',
    expires: 'ينتهي',
    cashFlowComparison: 'مقارنة التدفق النقدي',
    totalTransactions: 'إجمالي المعاملات',
    totalDeposits: 'إجمالي الإيداعات',
    totalWithdrawals: 'إجمالي السحوبات',
  },

  // Instruments
  instruments: {
    title: 'إدارة الأدوات المالية',
    library: 'مكتبة الأدوات',
    enabled: 'الأدوات المفعّلة',
    feed: 'أدوات البيانات',
    symbol: 'الرمز',
    category: 'الفئة',
    priceScale: 'مقياس السعر',
    leverage: 'الرافعة المالية',
    spread: 'السبريد',
    commission: 'العمولة',
    enable: 'تفعيل',
    disable: 'تعطيل',
    bulkEnable: 'تفعيل جماعي',
    settings: 'الإعدادات',
    tradeMode: 'وضع التداول',
    executionType: 'نوع التنفيذ',
    forex: 'فوركس',
    crypto: 'عملات رقمية',
    stocks: 'أسهم',
    indices: 'مؤشرات',
    commodities: 'سلع',
    general: 'عام',
    leverageLots: 'الرافعة والحجم',
    spreads: 'السبريدات',
    commissions: 'العمولات',
    riskManagement: 'إدارة المخاطر',
    advanced: 'متقدم',
    maxLeverage: 'أقصى رافعة مالية',
    minLotSize: 'أدنى حجم للصفقة',
    maxLotSize: 'أقصى حجم للصفقة',
    lotStep: 'خطوة الحجم',
    spreadType: 'نوع السبريد',
    spreadMarkup: 'هامش السبريد',
    fixedSpread: 'سبريد ثابت',
    commissionPerLot: 'العمولة لكل لوت',
    commissionType: 'نوع العمولة',
    stopLevel: 'مستوى الإيقاف',
    freezeLevel: 'مستوى التجميد',
    maxPositions: 'أقصى عدد صفقات',
    enableSuccess: 'تم تفعيل الأداة بنجاح',
    disableSuccess: 'تم تعطيل الأداة بنجاح',
    updateSuccess: 'تم تحديث الإعدادات بنجاح',
    bulkEnableSuccess: 'تم تفعيل الأدوات بنجاح',
  },

  // Clients
  clients: {
    title: 'العملاء',
    clientsList: 'قائمة العملاء',
    clientDetails: 'تفاصيل العميل',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    country: 'الدولة',
    kycStatus: 'حالة التحقق',
    accountCount: 'الحسابات',
    totalBalance: 'الرصيد الإجمالي',
    lastLogin: 'آخر تسجيل دخول',
    createdAt: 'تاريخ الإنشاء',
    verified: 'موثّق',
    pending: 'قيد الانتظار',
    rejected: 'مرفوض',
    searchPlaceholder: 'البحث عن عملاء...',
    nameOrEmail: 'الاسم أو البريد الإلكتروني...',
    editClient: 'تعديل العميل',
    configureOverride: 'تخصيص إعدادات المستخدم',
    noClientsFound: 'لا يوجد عملاء',
  },

  // Accounts
  accounts: {
    title: 'الحسابات',
    accountsList: 'قائمة الحسابات',
    accountDetails: 'تفاصيل الحساب',
    accountNumber: 'رقم الحساب',
    accountType: 'نوع الحساب',
    accountGroup: 'مجموعة الحساب',
    accountSettings: 'إعدادات الحساب',
    accountState: 'حالة الحساب',
    accountActive: 'الحساب نشط',
    balance: 'الرصيد',
    equity: 'حقوق الملكية',
    margin: 'الهامش',
    freeMargin: 'الهامش الحر',
    marginLevel: 'مستوى الهامش',
    leverage: 'الرافعة المالية',
    credit: 'ائتمان',
    debit: 'خصم',
    adjustBalance: 'تعديل الرصيد',
    changeLeverage: 'تغيير الرافعة',
    live: 'حي',
    demo: 'تجريبي',
    searchPlaceholder: 'البحث برقم الحساب أو البريد الإلكتروني...',
    accountNumberOrEmail: 'رقم الحساب أو البريد الإلكتروني...',
    balanceChange: 'تغيير الرصيد',
    reasonForAdjustment: 'سبب التعديل...',
    accountUpdatedSuccess: 'تم تحديث الحساب بنجاح',
    noAccountsFound: 'لا توجد حسابات',
  },

  // Trading
  trading: {
    title: 'التداول',
    positions: 'الصفقات',
    orders: 'الأوامر',
    history: 'السجل',
    symbol: 'الرمز',
    side: 'الاتجاه',
    volume: 'الحجم',
    openPrice: 'سعر الفتح',
    currentPrice: 'السعر الحالي',
    pnl: 'الربح والخسارة',
    buy: 'شراء',
    sell: 'بيع',
    open: 'مفتوح',
    pending: 'قيد الانتظار',
    closed: 'مغلق',
    closedAt: 'تاريخ الإغلاق',
    openedAt: 'تاريخ الفتح',
    price: 'السعر',
    totalTrades: 'إجمالي الصفقات',
    winningTrades: 'الصفقات الرابحة',
    losingTrades: 'الصفقات الخاسرة',
    totalPnL: 'إجمالي الربح والخسارة',
    account: 'الحساب',
    status: 'الحالة',
    swap: 'سواب',
    commission: 'عمولة',
    ticket: 'رقم الصفقة',
    noPositions: 'لا توجد صفقات مفتوحة',
    noOrders: 'لا توجد أوامر معلقة',
    noHistory: 'لا يوجد سجل تداول',
    bid: 'سعر البيع',
    ask: 'سعر الشراء',
    tradingManagement: 'إدارة التداول',
    liveMonitoring: 'المراقبة المباشرة',
    disconnected: 'منقطع',
    activeTraders: 'المتداولون النشطون',
    openPositions: 'الصفقات المفتوحة',
    pendingOrders: 'الأوامر المعلقة',
    floatPnL: 'الربح والخسارة العائمة',
    accountState: 'حالة الحساب',
    marginCall: 'نداء الهامش',
    stopOutRisk: 'خطر الإيقاف',
    live: 'مباشر',
    offline: 'غير متصل',
    snapshot: 'لقطة',
    marginLvl: 'مستوى الهامش',
    openTrades: 'صفقات مفتوحة',
    freeMargin: 'هامش حر',
    marginUsed: 'الهامش المستخدم',
    balance: 'الرصيد',
    equity: 'حقوق الملكية',
    credit: 'ائتمان',
    slTp: 'وقف الخسارة / جني الأرباح',
    fees: 'الرسوم',
    netPnL: 'صافي الربح والخسارة',
    grossPnL: 'إجمالي الربح والخسارة',
    reason: 'السبب',
    openedClosed: 'فتح / إغلاق',
    closePrice: 'سعر الإغلاق',
    reserved: 'محجوز',
    reservedMargin: 'هامش محجوز',
    created: 'تاريخ الإنشاء',
    triggerPrice: 'سعر التفعيل',
    duration: 'المدة',
    closedTrades: 'صفقات مغلقة',
    activeTrades: 'نشط',
    stopLoss: 'وقف الخسارة',
    takeProfit: 'جني الأرباح',
    closePosition: 'إغلاق الصفقة',
    cancelOrder: 'إلغاء الأمر',
    modifyPosition: 'تعديل الصفقة',
    thisActionCannotBeUndone: 'لا يمكن التراجع عن هذا الإجراء',
    enterStopLoss: 'أدخل سعر وقف الخسارة',
    enterTakeProfit: 'أدخل سعر جني الأرباح',
    filterTrading: 'تصفية التداول',
    traderSymbolAccount: 'المتداول، الرمز، الحساب...',
    noFound: 'لا يوجد {tab}',
    showingOf: 'عرض {from}–{to} من {total} متداول',
    traderCount: '{count} متداول · {total} {tab}',
    positionClosedSuccess: 'تم إغلاق الصفقة بنجاح',
    orderCancelledSuccess: 'تم إلغاء الأمر بنجاح',
    positionModifiedSuccess: 'تم تعديل الصفقة بنجاح',
    failedToClosePosition: 'فشل إغلاق الصفقة',
    failedToCancelOrder: 'فشل إلغاء الأمر',
    failedToModifyPosition: 'فشل تعديل الصفقة',
    invalidPosition: 'صفقة غير صالحة: معرّف مفقود',
  },

  // Reports
  reports: {
    title: 'التقارير',
    exposure: 'تقرير التعرض',
    profitability: 'ربحية العملاء',
    daily: 'التقرير اليومي',
    dateRange: 'نطاق التاريخ',
    totalExposure: 'إجمالي التعرض',
    netVolume: 'الحجم الصافي',
    topWinners: 'أعلى الرابحين',
    topLosers: 'أعلى الخاسرين',
    buyVolume: 'حجم الشراء',
    sellVolume: 'حجم البيع',
    positionCount: 'عدد الصفقات',
    winRate: 'معدل الفوز',
    rank: 'الترتيب',
    client: 'العميل',
    noData: 'لا توجد بيانات',
    totalVolume: 'الحجم الإجمالي',
    commission: 'العمولة',
    activeAccounts: 'الحسابات النشطة',
    export: 'تصدير',
    download: 'تنزيل',
    positions: 'صفقات',
    trades: 'تداولات',
    winning: 'رابحة',
    losing: 'خاسرة',
  },

  // Settings
  settings: {
    title: 'الإعدادات',
    brokerInfo: 'معلومات الوسيط',
    brokerSettings: 'إعدادات الوسيط',
    brokerName: 'اسم الوسيط',
    brokerNameRequired: 'اسم الوسيط *',
    brokerLogo: 'شعار الوسيط',
    brokerStatus: 'حالة الوسيط',
    domain: 'النطاق',
    primaryColor: 'اللون الأساسي',
    secondaryColor: 'اللون الثانوي',
    logo: 'الشعار',
    supportEmail: 'بريد الدعم',
    supportPhone: 'هاتف الدعم',
    generalInfo: 'المعلومات العامة',
    branding: 'الهوية البصرية',
    accountGroups: 'مجموعات الحسابات',
    addNewGroup: 'إضافة مجموعة جديدة',
    createFirstGroup: 'إنشاء أول مجموعة',
    noGroupsFound: 'لا توجد مجموعات حسابات',
    default: 'افتراضي',
    maxLeverage: 'أقصى رافعة مالية',
    marginCall: 'نداء الهامش',
    stopOut: 'إيقاف تلقائي',
    commission: 'العمولة',
    maxLotSize: 'أقصى حجم للصفقة',
    execution: 'التنفيذ',
    hedgingAllowed: 'التحوط مسموح',
    scalpingAllowed: 'السكالبينج مسموح',
    eaTrading: 'تداول EA',
    nbpEnabled: 'NBP مفعّل',
    saving: 'جارٍ الحفظ...',
    groupName: 'اسم المجموعة',
    description: 'الوصف',
    editGroup: 'تعديل المجموعة',
    deleteGroup: 'حذف المجموعة',
    cannotDeleteDefault: 'لا يمكن حذف المجموعة الافتراضية',
    confirmDelete: 'هل أنت متأكد من حذف "{name}"؟ لا يمكن التراجع عن هذا الإجراء.',
    groupCreatedSuccess: 'تم إنشاء المجموعة بنجاح',
    groupUpdatedSuccess: 'تم تحديث المجموعة بنجاح',
    groupDeletedSuccess: 'تم حذف المجموعة بنجاح',
    failedToSave: 'فشل حفظ المجموعة',
    failedToDelete: 'فشل حذف المجموعة',
    failedToLoad: 'فشل تحميل مجموعات الحسابات',
    configureYourBroker: 'تكوين معلومات الوسيط والتفضيلات',
    loadingSettings: 'جارٍ تحميل الإعدادات...',
    legalName: 'الاسم القانوني',
    licenseNumber: 'رقم الترخيص',
    environment: 'البيئة',
    contactInformation: 'معلومات التواصل',
    readOnly: 'للقراءة فقط',
    readOnlyContactSupport: 'للقراءة فقط — تواصل مع الدعم للتغيير',
    supportedLanguages: 'اللغات المدعومة',
    selectLanguagesDescription: 'اختر اللغات المتاحة في بوابة العملاء. يجب اختيار لغة واحدة على الأقل.',
    systemLimits: 'حدود النظام',
    maxAccounts: 'أقصى عدد حسابات',
    maxConcurrentTrades: 'أقصى صفقات متزامنة',
    maintenanceMode: 'وضع الصيانة',
    enableMaintenanceMode: 'تفعيل وضع الصيانة',
    maintenanceModeDescription: 'عند التفعيل، سيرى العملاء رسالة الصيانة بدلاً من المنصة',
    maintenanceMessage: 'رسالة الصيانة',
    maintenanceMessagePlaceholder: 'نحن نجري صيانة مجدولة حالياً. يرجى العودة قريباً.',
    saveChanges: 'حفظ التغييرات',
    howToConnectDomain: 'كيفية ربط نطاقك',
    unlockToEdit: 'فتح لتعديل النطاق',
    lockDomain: 'قفل النطاق',
    changingDomainWarning: 'تغيير النطاق قد يقطع وصول العملاء. هل أنت متأكد؟',
    changingDomainWarningLong: 'تغيير النطاق قد يقطع وصول العملاء وإعدادات DNS مؤقتاً. هل أنت متأكد؟',
    domainBreakWarning: '⚠️ تغيير النطاق قد يقطع وصول العملاء مؤقتاً',
    domainBreakWarningLong: '⚠️ تغيير النطاق قد يقطع وصول العملاء وتوجيه DNS مؤقتاً',
  },

  // Account Groups
  accountGroups: {
    title: 'مجموعات الحسابات',
    activeGroups: 'نشط',
    defaultGroups: 'افتراضي',
    addNewGroup: 'إضافة مجموعة جديدة',
    createFirstGroup: 'إنشاء أول مجموعة',
    noGroupsFound: 'لا توجد مجموعات حسابات',
    groupDetails: 'تفاصيل المجموعة',
    pricingOverrides: 'تخصيص التسعير',
    riskSettings: 'إعدادات المخاطر',
    tradingSettings: 'إعدادات التداول',
  },

  // Group Pricing
  groupPricing: {
    title: 'تخصيص تسعير المجموعة',
    infoBanner: 'تخصيص تسعير مجموعة الحسابات',
    infoDescription: 'تكوين تسعير مخصص لمجموعات الحسابات. اترك الحقول فارغة (NULL) لاستخدام الإعدادات الافتراضية للوسيط.',
    editPricingOverrides: 'تعديل تخصيص التسعير',
    spreadMarkup: 'هامش السبريد',
    spreadMarkupPips: 'هامش السبريد (نقاط)',
    commission: 'العمولة',
    commissionPerLot: 'العمولة لكل لوت (USD)',
    maxLeverageOverride: 'تخصيص أقصى رافعة مالية',
    brokerDefault: 'افتراضي الوسيط',
    useBrokerDefault: 'استخدام افتراضي الوسيط',
    clearUseBrokerDefault: 'مسح (استخدام افتراضي الوسيط)',
    saveOverrides: 'حفظ التخصيصات',
    overridesUpdatedSuccess: 'تم تحديث تسعير المجموعة بنجاح',
    failedToUpdate: 'فشل تحديث التخصيصات',
    leaveEmptyInfo: 'اترك الحقول فارغة لاستخدام إعدادات الوسيط. حدد القيم التي تريد تخصيصها فقط.',
    pips: 'نقاط',
    perLot: '/لوت',
  },

  // KYC
  kyc: {
    title: 'لوحة التحقق من الهوية',
    allKyc: 'كل التحققات',
    allStatus: 'كل الحالات',
    allKycStatus: 'كل حالات التحقق',
    pending: 'قيد الانتظار',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    verified: 'موثّق',
    actionNeeded: 'يتطلب إجراء',
    awaitingAction: 'في انتظار إجراء',
    allCaughtUp: 'كل شيء على ما يرام!',
    noApplications: 'لا توجد طلبات تحقق معلقة حالياً.',
    searchPlaceholder: 'البحث بالاسم أو البريد أو المعرّف...',
    nameEmailOrId: 'المعرّف أو الاسم أو البريد...',
    confirmApproval: 'تأكيد الموافقة على التحقق',
    confirmRejection: 'تأكيد الرفض — أدخل سبباً (مطلوب).',
    rejectionReason: 'اشرح سبب رفض هذا الطلب (مطلوب)',
    approveSuccess: 'تم الموافقة على التحقق بنجاح',
    rejectSuccess: 'تم رفض التحقق بنجاح',
    failedToApprove: 'فشل الموافقة على التحقق',
    failedToReject: 'فشل رفض التحقق',
    basicVerified: 'تحقق أساسي',
    fullVerified: 'تحقق كامل',
    allApplications: 'كل الطلبات',
    kycVerification: 'التحقق من الهوية',
    reviewManageDesc: 'مراجعة وإدارة طلبات التحقق',
    pluginSettings: 'إعدادات الإضافة',
    reviewKycApplication: 'مراجعة طلب التحقق',
    verificationLevel: 'مستوى التحقق',
    personalInformation: 'المعلومات الشخصية',
    fullName: 'الاسم الكامل',
    dateOfBirth: 'تاريخ الميلاد',
    nationality: 'الجنسية',
    addressLabel: 'العنوان',
    sourceOfFunds: 'مصدر الأموال',
    noPersonalData: 'لم يتم تقديم بيانات شخصية بعد',
    uploadedDocuments: 'الوثائق المرفوعة',
    noDocumentsUploaded: 'لم يتم رفع وثائق بعد',
    yourDecision: 'قرارك',
    approve: 'موافقة',
    reject: 'رفض',
    rejectionReasonLabel: 'سبب الرفض',
    submitting: 'جارٍ الإرسال...',
    submitReview: 'إرسال المراجعة',
    previewNotAvailable: 'المعاينة غير متاحة',
    downloadFile: 'تنزيل الملف',
    uploaded: 'تم الرفع',
    pendingReview: 'قيد المراجعة',
    allLevels: 'كل المستويات',
    allStatuses: 'كل الحالات',
    allActions: 'كل الإجراءات',
    userCol: 'المستخدم',
    currentLevel: 'المستوى الحالي',
    docsCol: 'الوثائق',
    lastUpdated: 'آخر تحديث',
    levelCol: 'المستوى',
    actionCol: 'الإجراء',
    performedBy: 'بواسطة',
    detailsCol: 'التفاصيل',
    dateTime: 'التاريخ والوقت',
    submittedCol: 'تاريخ التقديم',
    noApplicationsFound: 'لا توجد طلبات',
    noAuditRecords: 'لا توجد سجلات مراجعة',
    noMatchingApplications: 'لا توجد طلبات مطابقة',
    noPendingApplications: 'لا توجد طلبات معلقة',
    systemAuto: 'النظام (تلقائي)',
    admin: 'مدير',
    traderLabel: 'متداول',
    upgradedTo: 'ترقية إلى',
    pendingApplications: 'طلب معلق',
    pendingApplicationsPlural: 'طلبات معلقة',
    users: 'مستخدم',
    usersPlural: 'مستخدمون',
    records: 'سجل',
    recordsPlural: 'سجلات',
    applications: 'طلب',
    applicationsPlural: 'طلبات',
    totalUsers: 'إجمالي المستخدمين',
    basicVerifiedStat: 'تحقق أساسي',
    moderateVerified: 'تحقق متوسط',
    fullyVerified: 'تحقق كامل',
    pendingSuffix: '+{count} معلق',
    levelBasic: 'أساسي',
    levelModerate: 'متوسط',
    levelVerified: 'موثّق',
    notStarted: 'لم يبدأ',
    none: 'لا شيء',
    unknown: 'غير معروف',
    review: 'مراجعة',
    auditLog: 'سجل المراجعة',
    requiredDocuments: 'الوثائق المطلوبة',
    requiredDocsDesc: 'اختر الوثائق التي يجب على المتداولين رفعها لكل مستوى تحقق. يجب اختيار وثيقة واحدة على الأقل.',
    kycDocuments: 'وثائق {level} للتحقق',
    selected: '{count} محدد',
    approvalMode: 'وضع الموافقة',
    manualReview: 'مراجعة يدوية',
    autoApprove: 'موافقة تلقائية',
    autoApproveLevels: 'مستويات الموافقة التلقائية',
    basicKyc: 'تحقق أساسي',
    moderateKyc: 'تحقق متوسط',
    verifiedKyc: 'تحقق موثّق',
    enforceOnDeposit: 'إلزام التحقق عند الإيداع',
    enforceOnWithdrawal: 'إلزام التحقق عند السحب',
    basic: 'أساسي',
    moderate: 'متوسط',
    verified: 'موثّق',
    howItWorks: 'كيف يعمل:',
    howItWorksBullet1: 'المبالغ أقل من الحد الأساسي: لا يلزم التحقق',
    howItWorksBullet2: 'المبالغ فوق الأساسي: يلزم التحقق الأساسي',
    howItWorksBullet3: 'المبالغ فوق المتوسط: يلزم التحقق المتوسط',
    howItWorksBullet4: 'المبالغ فوق الموثّق: يلزم التحقق الكامل',
    saveConfiguration: 'حفظ الإعدادات',
    savingConfiguration: 'جارٍ الحفظ...',
    openKycDashboard: 'فتح لوحة التحقق',
    enableToViewStats: 'فعّل الإضافة لعرض الإحصائيات',
    statNone: 'لا شيء',
    docGovIdFrontLabel: 'وثيقة هوية حكومية (أمامية)',
    docGovIdFrontDesc: 'جواز سفر أو رخصة قيادة أو هوية وطنية - الوجه الأمامي',
    docGovIdBackLabel: 'وثيقة هوية حكومية (خلفية)',
    docGovIdBackDesc: 'الوجه الخلفي لبطاقة الهوية',
    docSelfieLabel: 'صورة سيلفي مع الهوية',
    docSelfieDesc: 'صورة أثناء حمل الهوية بجانب الوجه',
    docProofAddressLabel: 'إثبات العنوان',
    docProofAddressDesc: 'فاتورة خدمات أو كشف حساب بنكي (أقل من 3 أشهر)',
    docBankStatementLabel: 'كشف حساب بنكي',
    docBankStatementDesc: 'كشف حديث يظهر الاسم والحساب',
    docSourceFundsLabel: 'مصدر الأموال',
    docSourceFundsDesc: 'وثيقة تثبت مصدر أموال التداول',
    docEmploymentLabel: 'خطاب عمل',
    docEmploymentDesc: 'خطاب تأكيد من صاحب العمل',
    docTaxIdLabel: 'وثيقة الرقم الضريبي',
    docTaxIdDesc: 'شهادة التعريف الضريبي',
    docOtherLabel: 'وثائق أخرى',
    docOtherDesc: 'وثائق داعمة إضافية',
    auditActions: {
      submitted: 'تم التقديم',
      approved: 'موافق عليه',
      rejected: 'مرفوض',
      document_uploaded: 'تم رفع الوثيقة',
      document_approved: 'تمت الموافقة على الوثيقة',
      document_rejected: 'تم رفض الوثيقة',
      level_upgraded: 'تم رفع المستوى',
      resubmission: 'إعادة تقديم',
    },
  },

  // Deposits
  deposits: {
    title: 'الإيداعات',
    allDeposits: 'كل الإيداعات',
    allStatuses: 'كل الحالات',
    pending: 'قيد الانتظار',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    completed: 'مكتمل',
    searchPlaceholder: 'البحث في الإيداعات...',
    searchByIdNameEmail: 'البحث بالمعرّف أو الاسم أو البريد...',
    idNameOrEmail: 'المعرّف أو الاسم أو البريد...',
    depositProof: 'إثبات الإيداع',
    depositProofPdf: 'ملف PDF إثبات الإيداع',
    amount: 'المبلغ',
    method: 'الطريقة',
    status: 'الحالة',
    trader: 'المتداول',
    date: 'التاريخ',
    actions: 'إجراءات',
    approve: 'موافقة',
    reject: 'رفض',
    confirmApproval: 'تأكيد الموافقة — سيتم إضافة المبلغ لرصيد المتداول.',
    confirmRejection: 'تأكيد الرفض — أدخل سبباً (اختياري).',
    rejectionReason: 'سبب الرفض (اختياري)...',
    approveSuccess: 'تم الموافقة على الإيداع بنجاح',
    rejectSuccess: 'تم رفض الإيداع بنجاح',
    failedToApprove: 'فشل الموافقة على الإيداع',
    failedToReject: 'فشل رفض الإيداع',
    noDepositsFound: 'لا توجد إيداعات',
    proofThumbnail: 'صورة مصغرة للإثبات',
    zoomIn: 'تكبير',
    zoomOut: 'تصغير',
    openInNewTab: 'فتح في تبويب جديد',
    bank: 'بنك',
    crypto: 'عملة رقمية',
    card: 'بطاقة',
    bankPerCountry: 'بنك (حسب الدولة)',
    bankPerUser: 'بنك (حسب المستخدم)',
    bankTransfer: 'تحويل بنكي',
    bankTransferPerCountry: 'تحويل بنكي (حسب الدولة)',
    bankTransferPerUser: 'تحويل بنكي (حسب المستخدم)',
    averageDeposit: 'متوسط الإيداع',
  },

  // Withdrawals
  withdrawals: {
    title: 'السحوبات',
    allWithdrawals: 'كل السحوبات',
    allStatuses: 'كل الحالات',
    pending: 'قيد الانتظار',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    completed: 'مكتمل',
    searchPlaceholder: 'البحث في السحوبات...',
    searchByIdNameEmail: 'البحث بالمعرّف أو الاسم أو البريد...',
    idNameOrEmail: 'المعرّف أو الاسم أو البريد...',
    amount: 'المبلغ',
    method: 'الطريقة',
    status: 'الحالة',
    trader: 'المتداول',
    date: 'التاريخ',
    actions: 'إجراءات',
    approve: 'موافقة',
    reject: 'رفض',
    confirmApproval: 'تأكيد الموافقة — سيتم إرسال الأموال لتفاصيل الدفع.',
    confirmWithdrawalApproval: 'تأكيد الموافقة على السحب — سيتم إرسال الأموال للمتداول.',
    confirmRejection: 'تأكيد الرفض — أدخل سبباً (اختياري).',
    rejectionReason: 'سبب الرفض (اختياري)...',
    approveSuccess: 'تم الموافقة على السحب بنجاح',
    rejectSuccess: 'تم رفض السحب بنجاح',
    failedToApprove: 'فشل الموافقة على السحب',
    failedToReject: 'فشل رفض السحب',
    noWithdrawalsFound: 'لا توجد سحوبات',
    averageWithdrawal: 'متوسط السحب',
  },

  // Audit Log
  auditLog: {
    title: 'سجل المراجعة',
    allActions: 'كل الإجراءات',
    allEvents: 'كل الأحداث',
    allLevels: 'كل المستويات',
    searchPlaceholder: 'البحث في سجل المراجعة...',
    emailActionOrId: 'البريد أو الإجراء أو المعرّف...',
    event: 'الحدث',
    user: 'المستخدم',
    action: 'الإجراء',
    timestamp: 'الوقت',
    details: 'التفاصيل',
    level: 'المستوى',
    info: 'معلومات',
    warning: 'تحذير',
    error: 'خطأ',
    critical: 'حرج',
    noLogsFound: 'لا توجد سجلات مراجعة',
    administrativeAction: 'تم تسجيل إجراء إداري.',
    filterAuditLog: 'تصفية سجل المراجعة',
    reset: 'إعادة تعيين',
    eventType: 'نوع الحدث',
    apply: 'تطبيق',
    totalEvents: 'إجمالي الأحداث',
    depositEvents: 'أحداث الإيداع',
    withdrawalEvents: 'أحداث السحب',
    noEventsMatch: 'لا توجد أحداث تطابق هذا التصفية',
    noEntriesMatch: 'لا توجد إدخالات تطابق التصفية الحالية.',
    showAll: 'عرض الكل',
    events: 'حدث',
    eventsPlural: 'أحداث',
    totalEventsRecorded: 'إجمالي الأحداث المسجلة',
    performedBy: 'بواسطة',
    amount: 'المبلغ',
    paymentMethod: 'طريقة الدفع',
    balanceChange: 'تغيير الرصيد',
    statusChange: 'تغيير الحالة',
    rejectionReason: 'سبب الرفض',
    actionWithdrawalRequested: 'طلب سحب',
    actionDepositSubmitted: 'تم تقديم الإيداع',
    actionProofUploaded: 'تم رفع الإثبات',
    actionDepositApproved: 'تمت الموافقة على الإيداع',
    actionDepositRejected: 'تم رفض الإيداع',
    actionWithdrawalApproved: 'تمت الموافقة على السحب',
    actionWithdrawalRejected: 'تم رفض السحب',
    actionFundsLocked: 'تم تجميد الأموال',
    actionFundsReturned: 'تم إرجاع الأموال',
    fundsLockedSummary: 'تم تجميد الأموال من حساب المتداول بانتظار مراجعة السحب.',
    fundsReturnedSummary: 'تم إرجاع الأموال المجمدة للمتداول بعد الرفض.',
    depositsTab: 'الإيداعات',
    withdrawalsTab: 'السحوبات',
  },

  // Plugins
  plugins: {
    title: 'الإضافات',
    backToPlugins: 'العودة للإضافات',
    searchPlaceholder: 'البحث في الإضافات...',
    countrySelectNoMatch: 'لا يوجد تطابق',
    configurePlugin: 'تكوين الإضافة',
    pressEscToClose: 'اضغط {key} للإغلاق',
    loadingUsers: 'جارٍ التحميل...',
    available: 'متاح',
    active: 'نشط',
    activate: 'تفعيل',
    deactivate: 'إلغاء التفعيل',
    configure: 'تكوين',
    documentation: 'الوثائق',
    settings: 'الإعدادات',
    noPluginsFound: 'لا توجد إضافات',
    pluginDetails: 'تفاصيل الإضافة',
    version: 'الإصدار',
    author: 'المؤلف',
    description: 'الوصف',
    filterInactive: 'غير نشط',
    paymentGateways: 'بوابات الدفع',
    stripeTitle: 'Stripe',
    stripeDescription: 'قبول الدفعات عبر Stripe',
    paypalTitle: 'PayPal',
    paypalDescription: 'قبول الدفعات عبر PayPal',
    communicationTools: 'أدوات التواصل',
    twilioTitle: 'Twilio SMS',
    twilioDescription: 'إرسال إشعارات SMS',
    mailgunTitle: 'Mailgun',
    mailgunDescription: 'خدمة تسليم البريد الإلكتروني',
    bankFieldAccountHolder: 'صاحب الحساب',
    bankFieldBankName: 'اسم البنك',
    bankFieldAccountNumber: 'رقم الحساب',
    bankFieldRoutingNumber: 'رقم التوجيه (اختياري)',
    bankFieldSetAsDefault: 'تعيين كافتراضي',
    copyTradingTitle: 'نسخ التداول',
    copyTradingDescription: 'تفعيل ميزات نسخ التداول',
    tradingTools: 'أدوات التداول',
    mam: 'MAM/PAMM',
    apiKey: 'مفتاح API',
    apiSecret: 'سر API',
    accountSid: 'معرّف الحساب SID',
    authToken: 'رمز المصادقة',
    authDomain: 'نطاق المصادقة',
    appId: 'معرّف التطبيق',
    loadingPlugins: 'جارٍ تحميل الإضافات...',
    noPluginsMatch: 'لا توجد إضافات تطابق معاييرك',
    tryDifferentSearch: 'جرّب بحثاً أو تصفية مختلفة',
    tryAdjustingSearch: 'جرّب تعديل البحث أو التصفية',
    activeCount: '{count} نشط · {owned} مملوك · {available} في المتجر',
    ofPurchasedActive: 'من {count} مشترى نشط',
    expired: 'منتهي',
    expires: 'ينتهي',
    free: 'مجاني',
    buyPlugin: 'شراء — ${price}{cycle}',
    openInFullPage: 'فتح في صفحة كاملة',
    noConfigPanel: 'لا يوجد لوح تكوين لهذه الإضافة.',
    currentStatus: 'الحالة الحالية',
    failedToUpdateKyc: 'فشل تحديث إعدادات التحقق',
    filterAll: 'الكل',
    filterActive: 'نشط',
    filterOwned: 'مملوك',
    filterStore: 'المتجر',
    pluginNotFound: 'الإضافة غير موجودة',
    loadingPlugin: 'جارٍ تحميل الإضافة...',
    failedToLoadPlugin: 'فشل تحميل الإضافة',
    noConfigAvailable: 'لا يوجد لوح تكوين لهذه الإضافة.',
    activeStatus: 'نشط',
    editLabel: 'تعديل',
    newLabel: 'جديد',
    addLabel: 'إضافة',
    saveLabel: 'حفظ',
    cancelLabel: 'إلغاء',
    globalBankAccount: 'حساب بنكي عالمي',
    addBankAccount: 'إضافة حساب بنكي',
    defaultLabel: '(افتراضي)',
    cryptoWallet: 'محفظة رقمية',
    addCryptoWallet: 'إضافة محفظة رقمية',
    coinPlaceholder: 'العملة (مثل BTC)',
    networkPlaceholder: 'الشبكة (مثل mainnet)',
    walletAddressPlaceholder: 'عنوان المحفظة',
    labelOptionalPlaceholder: 'التسمية (اختياري)',
    paymentLink: 'رابط الدفع',
    addPaymentLink: 'إضافة رابط دفع',
    linkNamePlaceholder: 'الاسم (مثل Stripe Checkout)',
    perUserBankAccount: 'حساب بنكي لكل مستخدم',
    addUserBankMapping: 'إضافة ربط مستخدم → بنك',
    editExistingAccount: 'تعديل حساب موجود',
    assignedUsers: 'المستخدمون المعينون',
    pickTraders: 'اختر المتداولين',
    searchAddTrader: 'البحث وإضافة متداول...',
    perCountryBankAccount: 'حساب بنكي لكل دولة',
    addCountryBankMapping: 'إضافة ربط دولة → بنك',
    mappedCountries: 'الدول المربوطة',
    pickCountries: 'اختر الدول',
    searchAddCountries: 'البحث وإضافة دول...',
    badgeActive: 'نشط',
    badgeInactive: 'غير نشط',
    badgeExpired: 'منتهي',
    purchasePlugin: 'شراء الإضافة',
    paymentMethod: 'طريقة الدفع',
    generatePaymentAddress: 'إنشاء عنوان الدفع',
    sendExactly: 'أرسل بالضبط',
    toAddressBelow: 'إلى العنوان أدناه',
    paymentAddress: 'عنوان الدفع',
    waitingForPayment: 'في انتظار الدفع...',
    paymentDetected: 'تم رصد الدفع! جارٍ التأكيد...',
    confirmationsReceived: 'تم استلام {count} تأكيد',
    confirmationsReceivedPlural: 'تم استلام {count} تأكيدات',
    expiresIn: 'ينتهي خلال:',
    paymentId: 'معرّف الدفع:',
    paymentConfirmed: 'تم تأكيد الدفع!',
    pluginActivated: 'تم تفعيل {name}.',
    networkError: 'خطأ في الشبكة. يرجى المحاولة مجدداً.',
    failedToCreatePayment: 'فشل إنشاء الدفع',
    paymentExpired: 'انتهت مهلة الدفع. يرجى إنشاء دفع جديد.',
  },

  // API Docs
  apiDocs: {
    title: 'وثائق API',
    authentication: 'المصادقة',
    baseUrl: 'الرابط الأساسي:',
    allRequestsRequire: 'جميع الطلبات تتطلب ترويستين:',
    apiKeyManagement: 'إدارة مفاتيح API مع ضوابط الصلاحيات',
    billing: 'الفواتير',
    apiAccess: 'وصول API',
    apiAccessAddon: 'إضافة وصول API نشطة',
    buyAddon: 'شراء الإضافة — $199/شهر',
    getAccounts: 'GET /accounts',
    getAccountDetails: 'GET /accounts/:id',
    updateAccount: 'PATCH /accounts/:id',
    getDeposits: 'GET /deposits',
    approveDeposit: 'POST /deposits/:id/approve',
    rejectDeposit: 'POST /deposits/:id/reject',
    getWithdrawals: 'GET /withdrawals',
    approveWithdrawal: 'POST /withdrawals/:id/approve',
    rejectWithdrawal: 'POST /withdrawals/:id/reject',
    approvalsDescription: 'الموافقة على الإيداعات والسحوبات برمجياً',
    approveDepositDesc: 'الموافقة على إيداع (يجب أن تكون الحالة proof_uploaded). يضيف الرصيد ويسجل المعاملة. النص: notes?. يعيد balance_before و balance_after.',
    approveWithdrawalDesc: 'الموافقة على سحب معلق. تم تجميد الرصيد عند الطلب. النص: notes?',
    restApi: 'REST API',
    baseUrlLabel: 'الرابط الأساسي:',
    yourApiKeys: 'مفاتيح API الخاصة بك',
    noApiKeysYet: 'لا توجد مفاتيح API بعد',
    generateNewKey: 'إنشاء مفتاح جديد',
    revokeKey: 'إلغاء',
    rateLimit: 'حد المعدل',
    maxKeys: 'أقصى عدد مفاتيح',
    reqPerMin: '{limit} طلب/دقيقة',
    exampleRequest: 'مثال على الطلب',
    queryParameters: 'معاملات الاستعلام',
    endpoints: 'نقطة نهاية',
    endpointsPlural: 'نقاط نهاية',
    includedInPlan: 'مضمّن في خطة Enterprise',
    addonActive: 'إضافة وصول API نشطة',
    restApiAccess: 'وصول REST API',
    restApiDesc: 'وصول REST API متاح في خطة Enterprise أو كإضافة مستقلة لأي خطة.',
    featureReadClients: 'قراءة العملاء والحسابات وسجل التداول',
    featureApprovePayments: 'الموافقة على الإيداعات والسحوبات برمجياً',
    featureApiKeyManagement: 'إدارة مفاتيح API مع ضوابط الصلاحيات',
    featureRateLimit: 'حتى 60 طلباً في الدقيقة لكل مفتاح',
    featureInteractiveDocs: 'وثائق تفاعلية في لوحة التحكم',
    upgradeToEnterprise: 'الترقية إلى Enterprise',
    buyAddonPrice: 'شراء الإضافة — $199/شهر',
    generateApiKey: 'إنشاء مفتاح API',
    keyName: 'اسم المفتاح',
    keyNamePlaceholder: 'مثل: مفتاح الإنتاج',
    scopes: 'الصلاحيات',
    generating: 'جارٍ الإنشاء...',
    generateKey: 'إنشاء مفتاح',
    keyGenerated: 'تم إنشاء المفتاح',
    copySecretWarning: '⚠️ انسخ سرك الآن — لن يُعرض مرة أخرى.',
    apiKeyLabel: 'مفتاح API',
    apiSecretLabel: 'سر API',
    done: 'تم',
    enterKeyName: 'أدخل اسم المفتاح',
    failedToCreateKey: 'فشل إنشاء المفتاح',
    keyRevoked: 'تم إلغاء المفتاح',
    confirmRevoke: 'إلغاء مفتاح API؟ لا يمكن التراجع عن هذا.',
  },

  // Notifications
  notifications: {
    title: 'إعدادات الإشعارات',
    emailNotifications: 'إشعارات البريد الإلكتروني',
    smsNotifications: 'إشعارات SMS',
    pushNotifications: 'الإشعارات الفورية',
    deposits: 'الإيداعات',
    withdrawals: 'السحوبات',
    newClients: 'عملاء جدد',
    kycApplications: 'طلبات التحقق',
    systemAlerts: 'تنبيهات النظام',
    enabled: 'مفعّل',
    disabled: 'معطّل',
    saveSettings: 'حفظ الإعدادات',
    settingsSaved: 'تم حفظ الإعدادات بنجاح',
    notificationChannels: 'قنوات الإشعارات',
    configureChannels: 'تكوين كيفية إرسال المنصة للتنبيهات للعملاء.',
    saveAll: 'حفظ الكل',
    saving: 'جارٍ الحفظ...',
    enableToConfigure: 'فعّل لتكوين {title}',
    emailSmtp: 'البريد الإلكتروني (SMTP)',
    emailSmtpSubtitle: 'إرسال رسائل عبر خادم SMTP الخاص بك',
    recommended: 'موصى به',
    smtpHost: 'خادم SMTP',
    smtpPort: 'منفذ SMTP',
    usernameEmail: 'اسم المستخدم / البريد',
    passwordAppPassword: 'كلمة المرور / كلمة مرور التطبيق',
    fromEmail: 'بريد المرسل',
    fromName: 'اسم المرسل',
    useTls: 'استخدام TLS / STARTTLS',
    useTlsHint: 'موصى به للمنفذ 587. عطّل للمنفذ 465 (SSL).',
    sendTestEmail: 'إرسال بريد اختباري',
    pushFcm: 'الإشعارات الفورية (FCM)',
    pushFcmSubtitle: 'Firebase Cloud Messaging لـ Android وiOS والويب',
    pushSetupRequired: 'إعداد مطلوب',
    pushSetupDesc: 'انتقل إلى Firebase Console → إعدادات المشروع → حسابات الخدمة → إنشاء مفتاح خاص جديد.',
    serviceAccountCredentials: 'بيانات اعتماد حساب الخدمة',
    clientTokenStatus: 'حالة رمز العميل',
    clientTokenDesc: 'تُسجَّل رموز Push تلقائياً عند تسجيل العملاء الدخول.',
    testPush: 'اختبار Push',
    webAppConfig: 'تكوين تطبيق الويب',
    webAppConfigured: 'مكوّن — {project}',
    webAppRequired: 'مطلوب لإشعارات المتصفح والجوال',
    webAppWhereToFind: 'أين تجد هذه البيانات',
    webAppWhereToFindDesc: 'Firebase Console → إعدادات المشروع → تطبيقاتك → تطبيق الويب → إعداد SDK',
    saveWebConfig: 'حفظ تكوين الويب',
    vapidKey: 'مفتاح VAPID',
    vapidKeyHint: '— تبويب Cloud Messaging → شهادات Web Push → إنشاء زوج مفاتيح',
    credentialsOnFile: 'بيانات الاعتماد موجودة',
    credentialsStoredSecurely: 'مخزّنة بأمان على الخادم',
    replaceCredentials: 'استبدال',
    uploadServiceAccount: 'رفع ملف JSON لحساب الخدمة',
    uploadServiceAccountHint: 'انقر للاختيار — يتم التحقق من الملف وتخزينه بأمان',
    uploadingValidating: 'جارٍ الرفع والتحقق...',
    uploadSuccess: 'تم رفع بيانات Firebase بنجاح',
    uploadFailed: 'فشل الرفع — تأكد أن الملف هو JSON صالح لـ Firebase',
    saveWebConfigSuccess: 'تم حفظ تكوين Firebase للويب',
    saveWebConfigFailed: 'فشل حفظ تكوين الويب',
    smsTwilio: 'SMS (Twilio)',
    smsTwilioSubtitle: 'إرسال رسائل SMS عبر Twilio للعملاء',
    smsSetupRequired: 'إعداد مطلوب',
    smsSetupDesc: 'احصل على بياناتك من console.twilio.com',
    accountSid: 'معرّف الحساب SID',
    accountSidHint: 'يبدأ بـ AC...',
    authToken: 'رمز المصادقة',
    fromPhoneNumber: 'رقم الهاتف المرسل',
    fromPhoneHint: 'تنسيق E.164، مثل +12025551234',
    sendTestSms: 'إرسال SMS اختباري',
    statusConnected: 'متصل',
    statusError: 'خطأ',
    statusUntested: 'لم يختبر',
    statusTesting: 'جارٍ الاختبار...',
    notificationRouting: 'توجيه الإشعارات',
    notificationRoutingDesc: 'اختر القنوات لكل نوع إشعار',
    noChannelsEnabled: 'لا توجد قنوات مفعّلة',
    noChannelsEnabledDesc: 'فعّل قناة واحدة على الأقل لتكوين توجيه الإشعارات',
    notifMarginCall: 'نداء الهامش',
    notifMarginCallDesc: 'عند انخفاض مستوى هامش الحساب عن الحد',
    notifLiquidation: 'تصفية',
    notifLiquidationDesc: 'عند إغلاق الصفقات قسراً',
    notifDeposit: 'إيداع',
    notifDepositDesc: 'عند تأكيد إيداع',
    notifWithdrawal: 'سحب',
    notifWithdrawalDesc: 'عند معالجة سحب',
    notifTradeOpened: 'فتح صفقة',
    notifTradeOpenedDesc: 'عند فتح صفقة جديدة',
    notifTradeClosed: 'إغلاق صفقة',
    notifTradeClosedDesc: 'عند إغلاق صفقة',
    failedToLoad: 'فشل تحميل إعدادات الإشعارات',
    failedToSave: 'فشل الحفظ',
    testSuccess: 'اختبار {channel} ناجح — تحقق من صندوق الوارد/الجهاز',
    testFailed: 'فشل اختبار {channel}',
  },

  // Upgrade
  upgrade: {
    title: 'ترقية الخطة',
    currentPlan: 'الخطة الحالية',
    choosePlan: 'اختر خطة',
    basic: 'أساسي',
    professional: 'احترافي',
    enterprise: 'مؤسسي',
    perMonth: '/شهر',
    perYear: '/سنة',
    monthly: 'شهري',
    annually: 'سنوي',
    features: 'الميزات',
    selectPlan: 'اختيار الخطة',
    currentPlanLabel: 'الخطة الحالية',
    upgradeTo: 'الترقية إلى',
    contactSales: 'تواصل مع المبيعات',
    unlimitedClients: 'عملاء غير محدودين',
    unlimitedAccounts: 'حسابات غير محدودة',
    advancedReporting: 'تقارير متقدمة',
    prioritySupport: 'دعم أولوية',
    apiAccess: 'وصول API',
    customBranding: 'هوية بصرية مخصصة',
    whiteLabel: 'وايت ليبل',
    dedicatedManager: 'مدير حساب مخصص',
    upgradeAvailable: 'ترقية متاحة',
    plan: 'خطة',
    unlock: 'فتح',
    apiAccessFeature: '، وصول API',
    andMore: 'والمزيد',
    renew: 'تجديد',
  },

  // Theme
  theme: {
    light: 'الوضع الفاتح',
    dark: 'الوضع الداكن',
    toggle: 'تبديل الثيم',
  },

  // Language
  language: {
    english: 'English',
    arabic: 'العربية',
    turkish: 'Türkçe',
    select: 'اختر اللغة',
  },

  // Errors
  errors: {
    general: 'حدث خطأ ما',
    networkError: 'خطأ في الشبكة. يرجى التحقق من اتصالك.',
    unauthorized: 'غير مصرح. يرجى تسجيل الدخول مجدداً.',
    forbidden: 'تم رفض الوصول.',
    notFound: 'المورد غير موجود.',
    serverError: 'خطأ في الخادم. يرجى المحاولة لاحقاً.',
    actionFailed: 'فشل الإجراء',
  },

  // Success messages
  success: {
    saved: 'تم الحفظ بنجاح',
    updated: 'تم التحديث بنجاح',
    deleted: 'تم الحذف بنجاح',
    created: 'تم الإنشاء بنجاح',
    copied: 'تم النسخ إلى الحافظة',
  },

  // Time & Date
  time: {
    seconds: 'ثواني',
    minutes: 'دقائق',
    hours: 'ساعات',
    days: 'أيام',
    weeks: 'أسابيع',
    months: 'أشهر',
    years: 'سنوات',
    ago: 'مضت',
    justNow: 'الآن',
    today: 'اليوم',
    yesterday: 'أمس',
    tomorrow: 'غداً',
  },

  // Units
  units: {
    usd: 'دولار',
    eur: 'يورو',
    gbp: 'جنيه',
    lot: 'لوت',
    lots: 'لوتات',
    pips: 'نقاط',
    percent: '%',
  },

  cascade: {
    settingsArchitecture: 'هيكل الإعدادات',
    title: 'نظام الأولوية المتتالية',
    subtitle: 'تُحلّ الإعدادات من الأعلى ← الأدنى أولوية. اترك الحقل',
    subtitleNull: 'فارغاً (NULL)',
    subtitleFallthrough: 'لتخطي هذه الطبقة والانتقال للتالية.',
    resolutionOrder: 'ترتيب الحل:',
    firstNonNull: 'أول قيمة غير فارغة تفوز',
    highestPriority: 'أعلى أولوية — انقر على أي طبقة للاستكشاف',
    ifEmptyFallsThrough: '↓ إذا فارغ، ينتقل للتالية',
    priority: 'الأولوية',
    leaveFieldEmpty: 'اترك أي حقل فارغاً (NULL)',
    skipLayer: 'لتخطي هذه الطبقة والانتقال إلى',
    finalFallback: 'الحل النهائي — لا توجد طبقة أدنى.',
    hardLimitsNote: 'الحقول المُعلَّمة',
    hardLimitsNote2: 'هي حدود صارمة مفرضة على مستوى النظام، لا يمكن لأي طبقة تجاوزها.',
    layers: {
      userOverride: 'تخصيص المستخدم',
      userSublabel: 'صفقات خاصة لكل عميل',
      userTooltip: 'أعلى أولوية. أي حقل مُعيَّن هنا يتغلب على كل شيء آخر.',
      userFallsTo: 'مجموعة الحسابات (P2)',
      accountGroup: 'مجموعة الحسابات',
      groupSublabel: 'فئات VIP، قياسي، احترافي',
      groupTooltip: 'تُطبَّق على جميع عملاء هذه المجموعة.',
      groupFallsTo: 'إعدادات الرمز (P3)',
      symbolSettings: 'إعدادات الرمز',
      symbolSublabel: 'إعدادات الوسيط لكل أداة',
      symbolTooltip: 'يتحكم في التسعير وقواعد التنفيذ لكل أداة.',
      symbolFallsTo: 'الإعدادات الافتراضية (P4)',
      platformDefaults: 'الإعدادات الافتراضية',
      platformSublabel: 'احتياطي النظام والحدود القصوى',
      platformTooltip: 'أدنى أولوية للافتراضيات، لكنه يفرض حدوداً صارمة لا يمكن لأي طبقة تجاوزها.',
    },
    setByBroker: 'تعيين بواسطة الوسيط',
    setBySystemAdmin: 'تعيين بواسطة مدير النظام',
    goToClients: 'الانتقال للعملاء',
    goToAccountGroups: 'الانتقال لمجموعات الحسابات',
    goToInstruments: 'الانتقال للأدوات المالية',
    fields: {
      maxLeverage: 'أقصى رافعة مالية',
      maxLotSize: 'أقصى حجم للصفقة',
      marginCallLevel: 'مستوى نداء الهامش',
      stopOutLevel: 'مستوى الإيقاف التلقائي',
      maxOpenPositions: 'أقصى صفقات مفتوحة',
      commissionPerLot: 'العمولة لكل لوت',
      tradingDisabled: 'التداول معطّل',
      spreadMarkup: 'هامش السبريد',
      swapMarkup: 'هامش السواب',
      tripleSwapDay: 'يوم السواب الثلاثي',
      stopLevel: 'مستوى الإيقاف',
      freezeLevel: 'مستوى التجميد',
      defaultLeverage: 'الرافعة الافتراضية',
      defaultCommission: 'العمولة الافتراضية',
      defaultMarginCall: 'نداء الهامش الافتراضي',
      defaultStopOut: 'الإيقاف الافتراضي',
      maxLeverageCap: 'سقف أقصى رافعة',
      minMarginCall: 'أدنى نداء هامش',
      minStopOut: 'أدنى إيقاف تلقائي',
      maxCommissionCap: 'سقف أقصى عمولة',
      maxPositionsCap: 'سقف أقصى صفقات',
    },
    fieldDescs: {
      capLeverageClient: 'تحديد الرافعة لهذا العميل',
      limitPositionSize: 'تحديد حجم الصفقة لكل تداول',
      overrideAlertThreshold: 'تخصيص حد التنبيه',
      overrideAutoClose: 'تخصيص حد الإغلاق التلقائي',
      limitConcurrentTrades: 'تحديد الصفقات المتزامنة',
      customCommission: 'عمولة مخصصة (مثل VIP = 0)',
      killSwitch: 'مفتاح إيقاف طارئ لهذا العميل',
      groupCommission: 'عمولة على مستوى المجموعة',
      groupLeverage: 'سقف رافعة المجموعة',
      groupMarginCall: 'حد تنبيه المجموعة',
      groupStopOut: 'حد إغلاق تلقائي المجموعة',
      groupPositions: 'حد صفقات المجموعة',
      groupLotSize: 'حد حجم تداول المجموعة',
      pipsAddedSpread: 'نقاط مضافة للسبريد الخام',
      symbolCommission: 'عمولة خاصة بالرمز',
      overnightSwap: 'مضاف لمعدلات السواب الليلي',
      tripleSwapDay: 'اليوم الذي يُحسب فيه 3x سواب',
      symbolLeverage: 'سقف رافعة الرمز',
      symbolLotSize: 'حد حجم تداول الرمز',
      minSlTpDistance: 'أدنى مسافة لـ SL/TP بالنقاط',
      modificationFreeze: 'مسافة تجميد التعديل',
      fallbackLeverage: 'احتياطي إذا لم تحدد أي طبقة',
      fallbackCommission: 'معدل عمولة احتياطي',
      fallbackMarginCall: 'مستوى تنبيه احتياطي',
      fallbackStopOut: 'مستوى إغلاق تلقائي احتياطي',
      hardCeilingLeverage: 'سقف صارم — لا يمكن تجاوزه',
      hardFloorMarginCall: 'حد أدنى صارم — لا يمكن النزول عنه',
      hardFloorStopOut: 'حد أدنى صارم — لا يمكن النزول عنه',
      hardCeilingCommission: 'سقف صارم للعمولة',
      systemPositionLimit: 'حد الصفقات على مستوى النظام',
    },
  },

  emailTemplates: {
    loadingTemplates: 'جارٍ تحميل قوالب البريد...',
    loadingTemplate: 'جارٍ تحميل القالب...',
    retry: 'إعادة المحاولة',
    allTemplates: '← كل القوالب',
    customised: 'مخصص',
    custom: 'مخصص',
    default: 'افتراضي',
    subjectLine: 'سطر الموضوع',
    subjectPlaceholder: 'موضوع البريد...',
    editorTab: 'المحرر',
    htmlTab: 'HTML',
    previewTab: 'معاينة',
    variables: 'المتغيرات:',
    showLess: 'عرض أقل',
    clickToInsert: 'انقر لإدراج متغير:',
    saveTemplate: 'حفظ القالب',
    savingTemplate: 'جارٍ الحفظ...',
    resetToDefault: 'إعادة للافتراضي',
    resetting: 'جارٍ الإعادة...',
    back: 'رجوع',
    resetConfirm: 'إعادة القالب الافتراضي؟ ستُفقد تخصيصاتك.',
    subjectBodyRequired: 'الموضوع والمحتوى مطلوبان',
    activeBranding: 'الهوية البصرية النشطة',
    companyName: 'اسم الشركة',
    primaryColor: 'اللون الأساسي',
    logoUrl: 'رابط الشعار',
    noLogoSet: 'لم يتم تعيين شعار',
    emailFooter: 'تذييل البريد',
    brandingNote: 'لتحديث هويتك البصرية، انتقل إلى إعدادات الوسيط.',
    editBranding: 'تعديل الهوية',
    closeBranding: 'إغلاق الهوية',
    templateListDesc: 'انقر على قالب للتعديل. القوالب المخصصة تتجاوز الافتراضيات.',
    templateInfoNote: 'القوالب المعلّمة بـ "افتراضي" تستخدم التصميم المدمج مع هويتك. انقر لتخصيصها.',
    loadingBranding: 'جارٍ تحميل الهوية البصرية...',
    typeDepositApproved: 'موافقة على إيداع',
    typeDepositRejected: 'رفض إيداع',
    typeWithdrawalApproved: 'موافقة على سحب',
    typeWithdrawalRejected: 'رفض سحب',
    typeMarginCall: 'نداء الهامش',
    typeLiquidation: 'تصفية الحساب',
    typeKycApproved: 'موافقة على التحقق',
    typeKycRejected: 'رفض التحقق',
    typeWelcome: 'بريد الترحيب',
  },

  credits: {
    activeRules: 'القواعد النشطة',
    totalAwarded: 'إجمالي الممنوح',
    awardEvents: 'أحداث المنح',
    bonusRules: 'قواعد المكافأة',
    awardHistory: 'سجل المنح',
    newRule: 'قاعدة جديدة',
    manualAward: 'منح يدوي',
    noBonusRules: 'لا توجد قواعد مكافأة بعد. أضف واحدة لبدء منح الائتمان تلقائياً.',
    noCreditAwards: 'لا توجد منح ائتمان بعد.',
    deactivateConfirm: 'إلغاء تفعيل هذه القاعدة؟',
    revokeReason: 'سبب الإلغاء (اختياري):',
    operationFailed: 'فشلت العملية',
    bonusRuleTitle: 'قاعدة مكافأة {mode}',
    ruleName: 'اسم القاعدة (مثل مكافأة الترحيب)',
    percentOfDeposit: '% من الإيداع (مثل 20)',
    fixedAmountUsd: 'مبلغ ثابت (USD)',
    maxCreditCap: 'سقف أقصى ائتمان (اختياري)',
    minDepositQualify: 'أدنى إيداع للتأهل',
    expiresAfterDays: 'ينتهي بعد N أيام (اختياري)',
    ruleActive: 'نشط — يمنح تلقائياً عند الإيداعات المؤهلة',
    ruleDisabled: 'معطّل',
    savingDots: 'جارٍ الحفظ...',
    awardingDots: 'جارٍ المنح...',
    manualCreditAward: 'منح ائتمان يدوي',
    accountId: 'معرّف الحساب',
    userId: 'معرّف المستخدم',
    amountUsd: 'المبلغ (USD)',
    notesOptional: 'ملاحظات (اختياري)',
    awardCredit: 'منح ائتمان',
    infoWelcomeDeposit: 'قواعد WELCOME وDEPOSIT تُفعَّل تلقائياً عند الموافقة على الإيداع. GOODWILL وPROMOTION تُمنح يدوياً.',
    bonusWelcome: 'ترحيب',
    bonusDeposit: 'إيداع',
    bonusGoodwill: 'حسن نية',
    bonusPromotion: 'عرض ترويجي',
    statusRevoked: 'ملغى',
    statusExpired: 'منتهي',
  },

  pages: {
    websitePages: 'صفحات الموقع',
    websitePagesDesc: 'بناء وإدارة موقعك الإلكتروني.',
    pluginNotActive: 'الإضافة غير نشطة.',
    viewPlugins: 'عرض الإضافات',
    mainPages: 'الصفحات الرئيسية',
    legalPages: 'الصفحات القانونية',
    langs: 'لغات',
    save: 'حفظ',
    saved: 'تم الحفظ',
    error: 'خطأ',
    publish: 'نشر',
    unpublish: 'إلغاء النشر',
    published: 'منشور',
    draft: 'مسودة',
    tabBlocks: 'الكتل',
    tabSeo: 'SEO',
    addBlock: 'إضافة كتلة',
    addFirstBlock: 'إضافة أول كتلة',
    addFirstBlockHint: 'أضف أول كتلة محتوى',
    noBlocks: 'لا توجد كتل بعد',
    pageTitle: 'عنوان الصفحة',
    pageTitleHint: 'هذا هو العنوان الرئيسي المعروض في التنقل ورأس الصفحة',
    translatable: 'قابل للترجمة',
    pageSlug: 'عنوان URL للصفحة',
    seoTitle: 'عنوان SEO',
    seoDescription: 'وصف SEO',
    googlePreview: 'معاينة جوجل',
    noDescription: 'لا يوجد وصف.',
    catHeroLayout: 'Hero والتخطيط',
    catContent: 'المحتوى',
    catFeaturesData: 'الميزات والبيانات',
    catSocialProof: 'الدليل الاجتماعي',
    catCta: 'دعوة للعمل',
    catDocuments: 'المستندات والقانوني',
    catOther: 'أخرى',
    missing: 'مفقود',
    add: 'إضافة',
    addItem: 'إضافة عنصر',
    item: 'عنصر',
    notStarted: 'لم يبدأ',
  },

  userOverride: {
    title: 'تخصيص حساب المستخدم',
    infoBannerTitle: 'تخصيصات مستوى المستخدم (الطبقة 1)',
    infoBannerDesc: 'هذه الإعدادات تتجاوز إعدادات مجموعة حساب المستخدم. اترك الحقول فارغة (NULL) لاستخدام إعدادات المجموعة.',
    sectionTradingControl: 'التحكم في التداول',
    sectionRiskParameters: 'معاملات المخاطر',
    sectionPricingOverrides: 'تخصيص التسعير',
    disableTrading: 'تعطيل التداول',
    disableTradingSubLabel: 'منع هذا المستخدم من فتح صفقات جديدة',
    resetToGroupDefault: 'إعادة لافتراضي المجموعة',
    groupDefault: 'افتراضي المجموعة',
    maxLeverage: 'أقصى رافعة مالية',
    maxLotSize: 'أقصى حجم للصفقة',
    minLotSize: 'أدنى حجم للصفقة',
    marginCallLevel: 'مستوى نداء الهامش (%)',
    stopOutLevel: 'مستوى الإيقاف التلقائي (%)',
    maxOpenPositions: 'أقصى صفقات مفتوحة',
    commissionPerLot: 'العمولة لكل لوت (USD)',
    commissionPerLotHint: 'USD يُخصم لكل لوت قياسي متداول',
    minAboveMaxError: '⚠️ لا يمكن أن يتجاوز أدنى حجم أقصى حجم للصفقة',
    currentOverrideTitle: 'تخصيص نشط حالياً',
    currentOverrideDesc: 'هذا المستخدم لديه إعدادات مخصصة تتجاوز إعدادات مجموعته.',
    saveOverride: 'حفظ التخصيص',
    saving: 'جارٍ الحفظ...',
    saveSuccess: 'تم حفظ تخصيص المستخدم بنجاح',
    saveFailed: 'فشل حفظ تخصيص المستخدم',
    lots: 'لوتات',
    lotStep: 'خطوة اللوت',
  },

  symbolSettings: {
    sectionPricing: 'تسعير الوسيط',
    sectionRisk: 'حدود المخاطر',
    sectionExecution: 'قواعد التنفيذ',
    sectionOverrides: 'تخصيصات الأداة',
    sectionsLabel: 'الأقسام',
    pricingDesc: 'تعديلات مضافة على معدلات الأداة الخام لهذا الوسيط.',
    riskDesc: 'حدود الصفقات والرافعة المالية على مستوى الوسيط.',
    executionDesc: 'قيود وضع الأوامر وتعديلها.',
    overridesDesc: 'فعّل كل حقل لتطبيق تخصيص على مستوى الوسيط.',
    overridesInfoTitle: 'سواب الشراء / سواب البيع',
    overridesInfoDesc: 'يستبدلان معدل الأداة بالكامل عند التفعيل.',
    settingsTitle: 'إعدادات {symbol}',
    headerSubtitle: 'تكوين التسعير والمخاطر على مستوى الوسيط (الطبقة 3)',
    overrideActive: '{count} تخصيص نشط',
    overridesActive: '{count} تخصيصات نشطة',
    spreadMarkup: 'هامش السبريد',
    spreadMarkupHint: 'نقاط مضافة للسبريد الخام من مزود السيولة',
    commissionPerLot: 'العمولة لكل لوت',
    commissionPerLotHint: 'USD يُخصم لكل لوت قياسي متداول',
    swapMarkup: 'هامش السواب',
    swapMarkupHint: 'نقاط مضافة لمعدلات سواب الأداة.',
    tripleSwapDay: 'يوم السواب الثلاثي',
    tripleSwapDayHint: 'اليوم الذي يُحسب فيه السواب الثلاثي',
    maxLeverage: 'أقصى رافعة مالية',
    maxLeverageHint: 'أقصى رافعة مسموح بها لهذا الرمز',
    maxLotSize: 'أقصى حجم للصفقة',
    maxLotSizeHint: 'أقصى حجم صفقة لكل تداول',
    minLotSize: 'أدنى حجم للصفقة',
    minLotSizeHint: 'أدنى حجم صفقة لكل تداول',
    minAboveMaxError: '⚠️ لا يمكن أن يتجاوز أدنى حجم أقصى حجم للصفقة',
    stopLevel: 'مستوى الإيقاف',
    stopLevelHint: 'أدنى مسافة لـ SL/TP من السعر الحالي (نقاط)',
    freezeLevel: 'مستوى التجميد',
    freezeLevelHint: 'المسافة التي يُجمَّد عندها تعديل الأوامر (نقاط)',
    contractSize: 'حجم العقد',
    contractSizeHint: 'الوحدات لكل لوت. مثل 100000 للفوركس القياسي.',
    priceScale: 'مقياس السعر',
    priceScaleHint: 'المنازل العشرية لاقتباس السعر.',
    swapLong: 'سواب الشراء (معدل مباشر)',
    swapLongHint: 'معدل ليلي لصفقات الشراء. يستبدل معدل الأداة بالكامل.',
    swapShort: 'سواب البيع (معدل مباشر)',
    swapShortHint: 'معدل ليلي لصفقات البيع. يستبدل معدل الأداة بالكامل.',
    swapMode: 'وضع السواب',
    swapModeHint: 'كيفية حساب معدل السواب الليلي',
    maxVolume: 'أقصى حجم (لوتات)',
    maxVolumeHint: 'أقصى حجم صفقة واحدة بالنقاط لهذا الوسيط.',
    volumeStep: 'خطوة الحجم (لوتات)',
    volumeStepHint: 'أدنى زيادة في حجم التداول.',
    defaultBadge: 'افتراضي',
    pips: 'نقاط',
    pts: 'نقاط',
    lots: 'لوتات',
    decimals: 'منازل عشرية',
    dayMon: 'الاثنين',
    dayTue: 'الثلاثاء',
    dayWed: 'الأربعاء',
    dayThu: 'الخميس',
    dayFri: 'الجمعة',
    daySat: 'السبت',
    daySun: 'الأحد',
    loadingSettings: 'جارٍ تحميل الإعدادات...',
    saveSettings: 'حفظ الإعدادات',
    lotStep: 'خطوة اللوت',
  },

  accountGroupForm: {
    sectionsLabel: 'الأقسام',
    sectionBasic: 'المعلومات الأساسية',
    sectionPricing: 'تخصيص التسعير',
    sectionRisk: 'إدارة المخاطر',
    editTitle: 'تعديل مجموعة الحسابات',
    createTitle: 'إنشاء مجموعة حسابات',
    basicInfoTitle: 'المعلومات الأساسية',
    groupNameLabel: 'اسم المجموعة *',
    groupNamePlaceholder: 'مجموعة قياسية',
    descriptionLabel: 'الوصف',
    descriptionPlaceholder: 'وصف المجموعة...',
    groupActive: 'المجموعة نشطة',
    defaultGroup: 'المجموعة الافتراضية',
    pricingTitle: 'تخصيص التسعير',
    pricingDesc: 'اترك فارغاً لاستخدام إعدادات الوسيط. خصّص فقط إذا احتاجت المجموعة تسعيراً مختلفاً.',
    commissionPerLot: 'العمولة لكل لوت (USD)',
    commissionPerLotHint: 'USD يُخصم لكل لوت قياسي متداول',
    maxLeverage: 'أقصى رافعة مالية',
    maxLeverageHint: 'أقصى رافعة متاحة لهذه المجموعة',
    brokerDefault: 'افتراضي الوسيط',
    resetToNoLimit: 'إعادة تعيين بلا حد',
    riskTitle: 'إدارة المخاطر',
    marginCallLevel: 'مستوى نداء الهامش',
    marginCallHint: 'تنبيه عند وصول مستوى الهامش لهذه النسبة',
    stopOutLevel: 'مستوى الإيقاف التلقائي',
    stopOutHint: 'إغلاق تلقائي للصفقات عند هذا المستوى',
    maxOpenPositions: 'أقصى صفقات مفتوحة',
    maxOpenPositionsHint: 'أقصى عدد صفقات لكل حساب',
    maxLotSize: 'أقصى حجم للصفقة',
    maxLotSizeHint: 'أقصى حجم صفقة لكل تداول',
    minLotSize: 'أدنى حجم للصفقة',
    minLotSizeHint: 'أدنى حجم صفقة لهذه المجموعة',
    noLimit: 'بلا حد',
    lots: 'لوتات',
    marginBelowStopError: '⚠️ يجب أن يكون مستوى نداء الهامش أعلى من مستوى الإيقاف',
    minAboveMaxError: '⚠️ لا يمكن أن يتجاوز أدنى حجم أقصى حجم للصفقة',
    updateGroup: 'تحديث المجموعة',
    createGroup: 'إنشاء المجموعة',
    lotStep: 'خطوة اللوت',
  },

  cryptoCheckout: {
    paymentConfirmedTitle: 'تم تأكيد الدفع!',
    makePayment: 'إجراء الدفع',
    depositFunds: 'إيداع الأموال',
    purchaseItem: 'شراء {name}',
    subscribeTo: 'الاشتراك في {name}',
    selectPaymentMethod: 'اختر طريقة الدفع',
    payWith: 'الدفع بـ {currencies}',
    creatingPayment: 'جارٍ إنشاء الدفع...',
    continue: 'متابعة',
    sendExactly: 'أرسل بالضبط',
    approxUsd: '≈ ${amount} USD',
    hideQrCode: 'إخفاء رمز QR',
    showQrCode: 'عرض رمز QR',
    scanWithWallet: 'امسح بمحفظتك المحمولة',
    toThisAddress: 'إلى عنوان {network} هذا',
    expiresIn: 'ينتهي خلال',
    waitingForPayment: 'في انتظار الدفع...',
    waitingDesc: 'أرسل المبلغ بالضبط. سنرصده تلقائياً.',
    verifiedOnChain: 'تم التحقق على السلسلة بواسطة AmorPay.',
    pluginActivated: 'تم تفعيل {name}.',
    depositCredited: 'تم إضافة إيداعك لحسابك.',
    subscriptionActive: 'اشتراكك نشط الآن.',
    paymentConfirmed: 'تم تأكيد دفعتك.',
    done: 'تم',
    noItemSelected: 'لم يتم اختيار عنصر للشراء',
    failedToLoadOptions: 'فشل تحميل خيارات الدفع',
  },

  subscriptionGate: {
    accountSuspended: 'الحساب موقوف',
    subscriptionExpired: 'انتهى الاشتراك',
    suspendedDesc: 'تم إيقاف حسابك. يرجى التواصل مع الدعم لاستعادة الوصول.',
    expiredDesc: 'انتهى اشتراك {plan} وانتهت فترة السماح. جدّد لاستعادة الوصول الكامل.',
    renewSubscription: 'تجديد الاشتراك',
    signOut: 'تسجيل الخروج',
    needHelp: 'تحتاج مساعدة؟ تواصل مع',
    lastChance: '⚠️ فرصة أخيرة! انتهى اشتراك {plan}. ينتهي الوصول اليوم.',
    gracePeriodDay: 'انتهى اشتراك {plan}. لديك {days} يوم متبقٍ في فترة السماح.',
    gracePeriodDays: 'انتهى اشتراك {plan}. لديك {days} أيام متبقية في فترة السماح.',
    renewNow: 'جدّد الآن',
  },

  upgradePage: {
    renewTitle: 'تجديد الاشتراك',
    upgradeTitle: 'ترقية خطتك',
    currentlyOn: 'الخطة الحالية',
    graceDaysLeft: '{days} يوم متبقٍ في فترة السماح',
    graceDaysLeftPlural: '{days} أيام متبقية في فترة السماح',
    expired: 'منتهي',
    graceWarning: 'انتهى اشتراكك. لديك {days} يوم للتجديد قبل قفل الحساب.',
    graceWarningPlural: 'انتهى اشتراكك. لديك {days} أيام للتجديد قبل قفل الحساب.',
    expiredWarning: 'انتهى اشتراكك بالكامل. جدّد الآن لاستعادة الوصول.',
    renewOrUpgrade: 'يمكنك تجديد خطتك الحالية أو الترقية لمستوى أعلى.',
    monthly: 'شهري',
    yearly: 'سنوي',
    mostPopular: 'الأكثر شيوعاً',
    currentPlan: 'الخطة الحالية',
    perMonth: '/شهر',
    saveYearly: 'وفّر 10% — يُفوتر ${amount}/سنة',
    unlimitedTraders: 'متداولون غير محدودين',
    tradersCount: '{count} متداول',
    unlimitedAdmins: 'مديرون غير محدودين',
    adminsCount: '{count} مديرين',
    unlimitedInstruments: 'أدوات غير محدودة',
    instrumentsCount: '{count} أداة',
    feedUltra: 'بيانات فائقة السرعة',
    feedPriority: 'بيانات ذات أولوية',
    feedStandard: 'بيانات قياسية',
    fullApiAccess: 'وصول كامل لـ API',
    selected: 'محدد',
    selectPlan: 'اختيار الخطة',
    fullComparison: 'مقارنة كاملة',
    featureCol: 'الميزة',
    featureTraders: 'المتداولون',
    featureAdmins: 'المديرون',
    featureInstruments: 'الأدوات',
    featureFeedLatency: 'تأخير البيانات',
    featureApiAccess: 'وصول API',
    featureForex: 'فوركس',
    featureCrypto: 'عملات رقمية',
    featureCommodities: 'سلع',
    featureIndices: 'مؤشرات',
    featureStocks: 'أسهم',
    selectedPlan: 'الخطة المختارة:',
    selectToContinue: 'اختر خطة للمتابعة',
    perYear: '/سنة',
    renewNow: 'جدّد الآن',
    upgradeNow: 'ارقَّ الآن',
    failedToLoadPlans: 'فشل تحميل الخطط',
    selectPlanFirst: 'يرجى اختيار خطة أولاً',
    planActivated: 'تم تفعيل خطة {name}! 🎉',
  },

  sidebar: {
    sectionOverview: 'نظرة عامة',
    sectionManagement: 'الإدارة',
    sectionTrading: 'التداول',
    sectionFinance: 'المالية',
    sectionPlugins: 'الإضافات',
    sectionSystem: 'النظام',
    accountGroups: 'مجموعات الحسابات',
    cascadeGuide: 'دليل التسلسل',
    pluginStore: 'متجر الإضافات',
    kycVerification: 'التحقق من الهوية',
    kycDashboard: 'لوحة التحقق',
    kycConfig: 'إعداد التحقق',
    pages: 'الصفحات',
    credits: 'الرصيد',
    emailTemplates: 'قوالب البريد',
    restApi: 'REST API',
    advancedAnalytics: 'تحليلات متقدمة',
    descClients: 'المستخدمون · الإعدادات · التجاوزات',
    descGroups: 'المجموعات · الإعدادات · التجاوزات',
    descInstruments: 'الوسيط · الإعدادات · التجاوزات',
    descAccounts: 'الحسابات والأرصدة',
    descCascade: 'شرح نظام الأولويات',
    descAnalytics: 'رؤى مدعومة بالذكاء الاصطناعي',
    badgeLive: 'مباشر',
    badgeActive: 'نشط',
    badgeAddon: 'إضافة',
    badgePro: 'PRO',
    badgeApi: 'API',
    badgeConfig: 'إعداد',
    badgeHowItWorks: 'كيف يعمل',
    cascadeTipFallthrough: 'اترك الحقول فارغة للانتقال إلى الطبقة التالية',
  },

};